import * as d3 from 'd3';

function msToTime(duration) {
  /*
    1minute = 60000ms
    1hour = 60minutes = 3600000ms
   */
  const hour = Math.floor(duration / 3600000);
  const minute = Math.floor((duration - 3600000 * hour) / 60000);

  const hh = ('00' + hour).slice(-2);
  const mm = ('00' + minute).slice(-2);
  const ms = ('00000' + (duration % 60000)).slice(-5);

  const time = `${hh}:${mm}:${ms.slice(0, 2)}`;

  return time;
}

function findLastId(agents) {
  if (agents.length === 0) {
    return 0;
  }

  // sortは破壊的メソッドなので一旦コピー作っとく
  const tmpAgents = agents;

  tmpAgents.sort((a, b) => {
    return a.id < b.id ? 1 : -1;
  });

  return tmpAgents[0].id;
}

function execGiveBirth(agents, lastId, format, value, setting, addSpeed) {
  const random = Math.random() * 3000;

  setTimeout(
    agents.push({
      id: lastId + 1,
      ...format,
      x: format.x(value, setting.worldWidth),
      y: format.y(value, setting.worldHeight),
      theta: format.theta(value),
      speed_var: format.speed_var(value + addSpeed, setting.noiseSpeed),
      src: format.src(value),
      birthDate: new Date(),
    }),
    random
  );
}

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function calculateTimes(agentsLength) {
  const result = (() => {
    if (agentsLength < 10) {
      return Math.max(1, getRandomInt(4));
    }

    if (agentsLength < 20) {
      return Math.max(2, getRandomInt(8));
    }

    if (agentsLength < 40) {
      return Math.max(3, getRandomInt(9));
    }

    return Math.max(4, getRandomInt(10));
  })();

  return result;
}

// helps translate degrees and radian
const g2r = d3
  .scaleLinear()
  .domain([0, 360])
  .range([0, 2 * Math.PI]);

const r2g = d3
  .scaleLinear()
  .range([0, 360])
  .domain([0, 2 * Math.PI]);

export default {
  msToTime,
  findLastId,
  execGiveBirth,
  calculateTimes,
  g2r,
  r2g,
};
